<template>
  <div class="technology">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Technology</h4>
      <h1 class="jp-title">{{$t('technology.title')}}</h1>
    </div>
    <section class="jp-grey-bg">
      <div class="jp-line"></div>
      <div class="jp-column mt-5">
        <!-- <span class="title jp-grey-bg">{{$t('home.technology')}}</span> -->
        <span class="title jp-grey-bg">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('home.technology')}}</span>
        </span>
        <span class="en-common-title">Technology</span>
        <!-- <div class="text-right mb-2"><small class="jp-more" @click="moreNews"><i class="el-icon-arrow-right"></i> {{$t('common.more')}}</small></div> -->
        
        <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
          <el-col :span="12" :xs="24" class="mb-3 hidden-sm-and-up">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology2" class="image technology-img">
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="card-content">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="24" class="text-left">
                  <div class="jp-line-blue"></div>
                  <h3>{{$t('home.technologyName2')}}</h3>
                  <h3 class="en-title">Polyimide</h3>
                </el-col>
              </el-row>
              <div class="card-text">
                <p>{{$t('home.technologyContent2')}}</p>
                <p class="en-content">Excellent chemical corrosion resistance, thermodynamic stability and mechanical properties, polyimide is considered as one of the most promising polymer materials.</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3 hidden-xs-only">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology2" class="image technology-img">
            </div>
          </el-col>
        </el-row>
        
        <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology5" class="image technology-img">
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="card-content">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="24" class="text-left">
                  <div class="jp-line-blue"></div>
                  <h3>{{$t('home.technologyName5')}}</h3>
                  <h3 class="en-title">H2 storage & transport</h3>
                </el-col>
              </el-row>
              <div class="card-text">
                <p>{{$t('home.technologyContent5')}}</p>
                <p class="en-content">High heat of combustion, water as combustion product, Hydrogen is the cleanest energy in the world, which is rich in resources and sustainable.</p>
              </div>
            </div>
          </el-col>
        </el-row>
        
        <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="card-content">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="14" class="text-left">
                  <div class="jp-line-blue"></div>
                  <h3>{{$t('home.technologyName3')}}</h3>
                  <h3 class="en-title">Bio-degradable plastics</h3>
                </el-col>
              </el-row>
              <div class="card-text">
                <p>{{$t('home.technologyContent3')}}</p>
                <p class="en-content">Degradable Plastics can be decomposed into low-molecules by sunlight or microorganisms, and can be degraded into environmentally harmless substances under natural environment.</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology3" class="image technology-img">
            </div>
          </el-col>
        </el-row>
        
        <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
          <el-col :span="12" :xs="24" class="mb-3 hidden-xs-only">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology6" class="image technology-img">
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <div class="card-content">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="15" class="text-left">
                  <div class="jp-line-blue"></div>
                  <h3>{{$t('home.technologyName6')}}</h3>
                  <h3 class="en-title">Microreactor</h3>
                </el-col>
                <!-- <el-col :span="9" class="text-right">
                  <span class="jp-more ml-3" @click="technologyDetail()">
                    <img :src="iconRight" class="icon-image">
                    <span class="more-text">see more</span>
                  </span>
                </el-col> -->
              </el-row>
              <div class="card-text">
                <p>{{$t('home.technologyContent6')}}</p>
                <p  class="en-content">The continuous flow reaction of microreactor can minimize the by-products, to realize energy saving and operating safety.</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3 hidden-sm-and-up">
            <div class="jp-overflow-hidden t-card">
              <img :src="technology6" class="image technology-img">
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import technology1 from '@/assets/img/t1-1.png';
import technology2 from '@/assets/img/t1-2.jpg';
import technology3 from '@/assets/img/t1-3.jpg';
import technology4 from '@/assets/img/t1-4.png';
import technology5 from '@/assets/img/t1-5.jpg';
import technology6 from '@/assets/img/t1-6.jpg';
import mainBg from '@/assets/img/technology_bg.png';
export default {
  name: 'news',
  data () {
    return {
      technology1: technology1,
      technology2: technology2,
      technology3: technology3,
      technology4: technology4,
      technology5: technology5,
      technology6: technology6,
      mainBg: mainBg,
      rowType: ''
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
        this.alignType = ''
      } else {
        this.rowType = 'flex'
        this.alignType = 'bottom'
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 2rem;
  }

  .news-introduce {
    width: 1170px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
    .el-col {
      margin-bottom: 2.5rem;
    }
  }
}

@media (max-width: 768px){
  section {
    .jp-project-content {
      font-size: 1.7rem;

      .el-image {
        max-height: 104px;
      }
    }
    .news-introduce {
      width: 100%;
      line-height: 2.5rem;
      font-size: 1.6rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/technology.vue